/**
 *
 * @notice ManutenzioniModalSlice to handle state of ManutenzioniModal globally.
 *
 * @dev This module contains the reducer configuration and its initialization.
 * @dev Is the sucker wich contains features of this slice.
 *
 */

// Redux.
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// Axios.
import axios from "axios"
// gmapi.
import { API_KEY, aggiungiMacchinarioAPI } from "../../../common/gmApi"
// cookie.
import { tkbox, getCookie } from "../../../common/cookie"

/**
 *
 *  @dev Insert a new machine.
 *
 */
export const addMachine = createAsyncThunk(
    // Action route.
    "manutenzioni/addMachine",
    //
    // Async Function with axios http req.
    //
    // First param: { name: string }.
    //
    // Second param: "thunkAPI" callback function that should return a promise
    // handle with extraReducers to update the State.
    // It takes two parameter too: first is the value of the dispatched action,
    // and the second is the Thunk API config.
    //
    async ({
        name,
        reparto,
        matricola,
        matricola_interna,
        anno,
        marcatura_ce,
        assistenza_tecnica,
        nome_referente,
        numero_assistenza,
        email_assistenza,
        allegato
    }, thunkAPI) => {
        try {
            const bodyFormData = new FormData()

            // console.log({allegato});

            bodyFormData.append('allegato', allegato, allegato)

            const response = await axios.post(
                // url.
                aggiungiMacchinarioAPI,
                // body.
                bodyFormData,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        nome: name,
                        reparto: reparto,
                        matricola: matricola,
                        matricola_interna: matricola_interna,
                        anno: anno,
                        marcatura_ce: marcatura_ce,
                        assistenza_tecnica: assistenza_tecnica,
                        nome_referente: nome_referente,
                        numero_assistenza: numero_assistenza,
                        email_assistenza: email_assistenza,
                    },
                }
            )

            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    // else reject gmapi response error.
                    //console.error('Error "addMachine":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "addMachine":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            // If something get wrong then reject the error.
            console.error('Error "addMachine":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/**
 *
 *  @dev Create "manutenzioniModalSlice" feature.
 *
 */
export const manutenzioniModalSlice = createSlice({
    // Name, used in action types.
    name: "manutenzioniModal",
    // The initial state for the reducer.
    initialState: {
        modalIsOpen: false,     // Modal is open or not.
        modalIsFetching: false, // AsyncThunk is calling an API.
        modalIsSuccess: false,  // AsyncThunk is success from API call.
        modalIsError: false,    // AsyncThunk is fail from API call.
        modalErrorMsg: "",      // Error message container.
    },
    // Reducers, an object of "case reducers".
    // Key names will be used to generate actions.
    reducers: {
        clearState: (state) => {
            state.modalIsError = false
            state.modalIsSuccess = false
            state.modalIsFetching = false

            return state
        },
        openModal: (state) => {
            state.modalIsOpen = true
        },
        closeModal: (state) => {
            state.modalIsOpen = false
        },
    },
    // AsyncThunk Reducers.
    // A "builder callback" function used to add more reducers, or
    // an additional object of "case reducers", where the keys should be other
    // action types.
    extraReducers: (builder) => {
        builder
            /**
             *
             * addMachine.
             *
             */
            .addCase(addMachine.fulfilled, (state) => {
                state.modalIsFetching = false
                state.modalIsSuccess = true
            })
            .addCase(addMachine.pending, (state) => {
                state.modalIsFetching = true
            })
            .addCase(addMachine.rejected, (state, action) => {
                state.modalIsFetching = false
                state.modalIsError = true
                state.modalErrorMsg = action.payload
            })
    },
})

// Export the reducer.
export const { clearState, openModal, closeModal } = manutenzioniModalSlice.actions

// Export the Slice by name.
export const manutenzioniModalSelector = (state) => state.manutenzioniModal
